import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {createTimeRegMutation, CreateTimeRegInput} from './__generated__/createTimeRegMutation.graphql';

// A minimal createTimeReg for the ticketing "log time on a linked task" flow.
// Unlike web-front's create_time_registration_mutation.modern.js (which pulls
// custom fields and timesheet fragments), this only needs to confirm success
// and refresh the task's rollup; the ticket detail view refetches afterwards.
const mutation = graphql`
	mutation createTimeRegMutation($input: CreateTimeRegInput!) {
		createTimeReg(input: $input) {
			errors
			task {
				id
				totalMinutesRegistered
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateTimeRegInput,
	onCompleted?: (r: createTimeRegMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<createTimeRegMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'createTimeRegMutation'};
